module.exports = __webpack_public_path__ + "static/HeaderImage-1-min-daea9ba66c0cccca9fe2b63896ec05c1.jpg";